import { createSlice } from "@reduxjs/toolkit";
import {
  fetchRespondentCases,
  quickViewDetailsAction,
  fetchCaseDocumentsAction,
  createCaseDocumentAction,
} from "../../actions/respondent/respondentActions";

const initialState = {
  loading: false,
  cases: [],
  error: null,
  quickView: null,
  quickViewLoading: false,
  documents: [],
  documentsByCase: [],
  documentsCount: 0,
  documentsLoading: false,
  documentsError: null,
  uploadingDocument: false,
  documentUploadError: null,
};

const respondentSlice = createSlice({
  name: "respondent",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchRespondentCases.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRespondentCases.fulfilled, (state, action) => {
        state.loading = false;
        state.cases = action.payload?.cases || [];
      })
      .addCase(fetchRespondentCases.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(quickViewDetailsAction.pending, (state) => {
        state.quickViewLoading = true;
        state.error = null;
      })
      .addCase(quickViewDetailsAction.fulfilled, (state, action) => {
        state.quickViewLoading = false;
        state.quickView = action.payload;
      })
      .addCase(quickViewDetailsAction.rejected, (state, { payload }) => {
        state.quickViewLoading = false;
        state.quickView = null;
        state.error = payload;
      })
      .addCase(fetchCaseDocumentsAction.pending, (state) => {
        state.documentsLoading = true;
        state.documentsError = null;
      })
      .addCase(fetchCaseDocumentsAction.fulfilled, (state, action) => {
        state.documentsLoading = false;
        state.documents = action.payload?.documents || [];
        state.documentsByCase = action.payload?.cases || [];
        state.documentsCount = action.payload?.count || 0;
      })
      .addCase(fetchCaseDocumentsAction.rejected, (state, { payload }) => {
        state.documentsLoading = false;
        state.documentsError = payload;
      })
      .addCase(createCaseDocumentAction.pending, (state) => {
        state.uploadingDocument = true;
        state.documentUploadError = null;
      })
      .addCase(createCaseDocumentAction.fulfilled, (state) => {
        state.uploadingDocument = false;
        state.documentUploadError = null;
      })
      .addCase(createCaseDocumentAction.rejected, (state, { payload }) => {
        state.uploadingDocument = false;
        state.documentUploadError = payload;
      }),
});

export default respondentSlice.reducer;
